











import { Vue, Component, Prop } from "vue-property-decorator";
import QuestionarioReview from "../components/ReviewDoc/QuestionarioReview.vue";
import { bus } from "../main";
import * as data from "../_store/data.module";

@Component({
  components: {
    QuestionarioReview
  }
})
export default class QuestionarioDoc extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() soggetto!: string; //entità che visualizza l'elenco documenti
  @Prop() tipoQuestionario!: string;
  @Prop() nomeSoggetto!: string;
  private questionario: any;
  private show: boolean;

  constructor() {
    super();
    this.questionario = {};
    this.show = false;
  }

  loadQuestionario() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType,
      tipoQuestionario: this.tipoQuestionario
    };
    data
      .dispatchRisposteQuestionario(this["$store"], payload)
      .then(result => {
        this.questionario = result;
        this.show = true;
        // bus.$emit("openDocQuestionarioReview", this.questionario);
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    this.loadQuestionario();
  }
}
